import palette from 'constants/palette'
import { StyleObject } from 'styletron-react'

// A 1px solid border expressed as LONGHAND props (width/style/color per side),
// for use inside a uikit `overrides.BaseButton.style` object. uikit's BaseButton
// resets borders with longhand, so adding a `border` shorthand alongside trips
// Styletron's "mixing shorthand and longhand … unsupported with atomic
// rendering" warning. Returning a typed StyleObject also lets the 'solid'
// literals check without an `as const` assertion. Centralized here so the
// workaround lives in one place (a future uikit fix touches a single spot).
export const solidBorder = (color: string): StyleObject => ({
  borderTopWidth: '1px',
  borderRightWidth: '1px',
  borderBottomWidth: '1px',
  borderLeftWidth: '1px',
  borderTopStyle: 'solid',
  borderRightStyle: 'solid',
  borderBottomStyle: 'solid',
  borderLeftStyle: 'solid',
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
})

// Space between an inline text-link's label and its trailing arrow. Shared by
// the gate card's "Set up" link and the signal panel's "Set up webhooks" link.
export const LINK_ARROW_GAP = '6px'

// Flush, bold, blue text-link treatment for a `kind="minimal"` uikit Button,
// used by every inline "Set up webhooks →"-style link on this page.
//
// uikit's `size` presets bake in horizontal padding (1.5rem at the default
// STANDARD), which indents the label past the copy it sits under. uikit also
// spreads a consumer `overrides.BaseButton` LAST, REPLACING its own kind/size
// preset rather than merging (see Button.js's `...(overrides || {})`), so a
// padding-only override would strip the kind="minimal" color composition and
// fall back to baseweb's raw greyscale default (`primary400` = #AFAFAF). The
// complete styling therefore has to be restated here — the same contract
// TourPager and ChatInput work around.
export const INLINE_LINK_OVERRIDES = {
  BaseButton: {
    style: {
      // Longhand, and strings: uikit's BaseButton resets padding with longhand
      // props, so a `padding` shorthand here trips Styletron's shorthand/longhand
      // mixing warning (same reason solidBorder above exists).
      paddingTop: '0px',
      paddingBottom: '0px',
      paddingLeft: '0px',
      paddingRight: '0px',
      backgroundColor: 'transparent',
      color: palette.belizeHole,
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 700,
      ':hover:enabled': {
        backgroundColor: 'transparent',
        textDecoration: 'underline',
      },
      ':disabled': { backgroundColor: 'transparent', color: palette.grey40 },
    },
  },
}
